import { render, staticRenderFns } from "./CartCalculator.vue?vue&type=template&id=edd00f10&"
import script from "./CartCalculator.vue?vue&type=script&lang=js&"
export * from "./CartCalculator.vue?vue&type=script&lang=js&"
import style0 from "./CartCalculator.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports